import lodash from 'lodash';

function createOrRemove(list, value) {
    const lst = lodash.cloneDeep(list);
    const index = lst.findIndex(item => item.id === value.id);
    if(index > -1) {
        lst.splice(index, 1);
    }else {
        lst.push(value);
    }
    return lst;
}

function fileNameCSV(extension = '.csv') {
    let today = new Date();
    let y = today.getFullYear();
    let m = today.getMonth() + 1;
    let d = today.getDate();
    let h = today.getHours();
    let mi = today.getMinutes();
    let s = today.getSeconds();
    return `${y}${m}${d}${h}${mi}${s}${extension}`;
}

export {createOrRemove, fileNameCSV};